
import { defineComponent, reactive } from "vue";
import RapportFilter from "./RapportFilter.vue";
import { useSequencesRapport } from "@/graphql/rapport/sequences.rapport";
import { activeActivity } from "@/plugins/i18n";
import SequenceTicketReprint from "@/components/sequence/SequenceTicketReprint.vue";
import { CONSTANTS } from "@/graphql/utils/utils";
import { SequencesRapportOutput } from "@/graphql/types";
import { getActiveTerminal } from "@/graphql/sequence/active.sequence";

export default defineComponent({
  name: "SequencesRapport",
  components: { SequenceTicketReprint, RapportFilter },
  setup() {
    const reprintDialog = reactive({
      sequenceId: "",
      visible: false,
    });
    function showReprint({
      sequenceId,
      terminalId,
      terminal,
    }: SequencesRapportOutput) {
      localStorage.setItem(
        CONSTANTS.activeTerminal,
        JSON.stringify({
          ...getActiveTerminal(),
          id: terminalId,
          name: terminal,
        })
      );
      reprintDialog.sequenceId = sequenceId;
      reprintDialog.visible = true;
    }
    return {
      ...useSequencesRapport(),
      currencySymbol: activeActivity.value.currencySymbol,
      rowsPerPageOptions: CONSTANTS.rowsPerPageOptions,
      reprintDialog,
      showReprint,
    };
  },
  created() {
    this.initData();
  },
});
